module.exports = __webpack_public_path__ + "media/images/new-comment-icon-d8d2f5ce4dd9ec8358b89b9c1210640a.png";